import { RechargeType, RechargeTypeInfo } from '@vacationtracker/shared/types/recharge-type'

export function getRechargeTypeInfo(
  type: RechargeType,
  formatMessage: ({ id }: { id: string }) => string
): RechargeTypeInfo {
  const infoMap: Record<RechargeType, RechargeTypeInfo> = {
    [RechargeType.SOCIAL_SPRINTER]: {
      emoji: '🚀',
      tagline: formatMessage({ id: 'rechargeType.info.socialSprinter.tagline' }),
      optimalPTO: formatMessage({ id: 'rechargeType.info.socialSprinter.optimalPTO' }),
      tips: [
        formatMessage({ id: 'rechargeType.info.socialSprinter.tip1' }),
        formatMessage({ id: 'rechargeType.info.socialSprinter.tip2' }),
        formatMessage({ id: 'rechargeType.info.socialSprinter.tip3' }),
        formatMessage({ id: 'rechargeType.info.socialSprinter.tip4' }),
      ],
    },
    [RechargeType.STRUCTURED_SOCIALIZER]: {
      emoji: '🗓️',
      tagline: formatMessage({ id: 'rechargeType.info.structuredSocializer.tagline' }),
      optimalPTO: formatMessage({ id: 'rechargeType.info.structuredSocializer.optimalPTO' }),
      tips: [
        formatMessage({ id: 'rechargeType.info.structuredSocializer.tip1' }),
        formatMessage({ id: 'rechargeType.info.structuredSocializer.tip2' }),
        formatMessage({ id: 'rechargeType.info.structuredSocializer.tip3' }),
        formatMessage({ id: 'rechargeType.info.structuredSocializer.tip4' }),
      ],
    },
    [RechargeType.SPONTANEOUS_SOLOIST]: {
      emoji: '🌙',
      tagline: formatMessage({ id: 'rechargeType.info.spontaneousSoloist.tagline' }),
      optimalPTO: formatMessage({ id: 'rechargeType.info.spontaneousSoloist.optimalPTO' }),
      tips: [
        formatMessage({ id: 'rechargeType.info.spontaneousSoloist.tip1' }),
        formatMessage({ id: 'rechargeType.info.spontaneousSoloist.tip2' }),
        formatMessage({ id: 'rechargeType.info.spontaneousSoloist.tip3' }),
        formatMessage({ id: 'rechargeType.info.spontaneousSoloist.tip4' }),
      ],
    },
    [RechargeType.DEEP_RESTORER]: {
      emoji: '🖼️',
      tagline: formatMessage({ id: 'rechargeType.info.deepRestorer.tagline' }),
      optimalPTO: formatMessage({ id: 'rechargeType.info.deepRestorer.optimalPTO' }),
      tips: [
        formatMessage({ id: 'rechargeType.info.deepRestorer.tip1' }),
        formatMessage({ id: 'rechargeType.info.deepRestorer.tip2' }),
        formatMessage({ id: 'rechargeType.info.deepRestorer.tip3' }),
        formatMessage({ id: 'rechargeType.info.deepRestorer.tip4' }),
      ],
    },
  }

  return infoMap[type]
}

export function getRechargeTypeDisplayName(
  type: RechargeType,
  formatMessage: ({ id }: { id: string }) => string
): string {
  const nameMap: Record<RechargeType, string> = {
    [RechargeType.SOCIAL_SPRINTER]: formatMessage({ id: 'rechargeType.prompt.card.socialSprinter' }),
    [RechargeType.STRUCTURED_SOCIALIZER]: formatMessage({ id: 'rechargeType.prompt.card.structuredSocializer' }),
    [RechargeType.SPONTANEOUS_SOLOIST]: formatMessage({ id: 'rechargeType.prompt.card.spontaneousSoloist' }),
    [RechargeType.DEEP_RESTORER]: formatMessage({ id: 'rechargeType.prompt.card.deepRestorer' }),
  }
  return nameMap[type]
}

